module.exports = __webpack_public_path__ + "static/media/taxa3.4f94a1e1.png";